(ns io.daskul.webapp.widgets.form.editable-cell
  "Editable cell component for inline table widget.

   Supports inline editing with click-to-edit behavior:
   - Display mode: Shows value, click to edit
   - Edit mode: Shows input, saves on blur/Enter, cancels on Escape"
  (:require
   [uix.core :as uix :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.format :as format]))

(defui editable-cell
  "Inline editable cell with display/edit modes.

   Props:
   - value: Current value
   - input-type: :text | :number | :currency
   - on-change: (fn [new-value]) - Called when value is saved"
  [{:keys [value input-type on-change]}]
  (let [[editing? set-editing!] (uix/use-state false)
        [local-value set-local-value!] (uix/use-state value)

        ;; Reset local value when external value changes
        _ (uix/use-effect
           (fn []
             (set-local-value! value)
             js/undefined)
           [value])

        numeric? (contains? #{:number :currency} input-type)

        handle-save
        (fn []
          (on-change (if numeric? (format/parse-number local-value) local-value))
          (set-editing! false))

        handle-cancel
        (fn []
          (set-local-value! value)
          (set-editing! false))

        handle-key-down
        (fn [e]
          (case (.-key e)
            "Enter" (handle-save)
            "Escape" (handle-cancel)
            nil))]

    (if editing?
      ;; Edit mode - show input
      (if numeric?
        ($ ui/number-input
          (merge {:value (if (nil? local-value) "" local-value)
                  :autoFocus true
                  :hideControls true
                  :onChange set-local-value!
                  :onBlur handle-save
                  :onKeyDown handle-key-down
                  :size "xs"
                  :styles {:input {:fontSize "14px"}}}
                 (if (= :currency input-type)
                   (format/currency-input-props)
                   (format/number-input-props))))
        ($ ui/text-input
          {:value (or local-value "")
           :autoFocus true
           :onChange #(set-local-value! (.. % -target -value))
           :onBlur handle-save
           :onKeyDown handle-key-down
           :size "xs"
           :styles {:input {:fontSize "14px"}}}))

      ;; Display mode - show value as clickable
      ($ :span.editable-value
        {:onClick #(do
                     (set-local-value! value)
                     (set-editing! true))
         :style {:cursor "pointer"
                 :padding "4px"
                 :borderRadius "3px"
                 :display "inline-block"
                 :minWidth "100%"}}
        (case input-type
          :currency (format/format-currency (or value 0))
          :number (str (or value 0))
          (or value "—"))))))
